import React from "react";

function Hero() {
  return (
    <section
      id="home"
      className="bg-light-gray min-vh-100 d-flex align-items-center"
    >
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h1 className="display-4 fw-bold mb-4 text-dark">
              مرحباً، أنا <span className="text-primary">مطور ويب شامل</span>
            </h1>
            <p className="lead mb-5 text-muted">
              أنشئ تطبيقات ويب متكاملة وتجارب مستخدم مميزة
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-3">
              <a
                href="#projects"
                className="btn btn-primary fw-medium px-4 py-2 shadow-sm"
              >
                عرض أعمالي
              </a>
              <a
                href="#contact"
                className="btn btn-outline-primary fw-medium px-4 py-2 shadow-sm"
              >
                تواصل معي
              </a>
            </div>
            <div className="mt-5 pt-3">
              <div className="d-flex justify-content-center gap-4">
                <a
                  href="https://github.com/Salahaldeen77"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon bg-white text-dark shadow-sm fs-3"
                >
                  <i className="fab fa-github"></i>
                </a>
                <a
                  href="https://wa.me/967784442005"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon bg-white text-dark shadow-sm fs-3"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a
                  href="https://t.me/Salahaldeen967"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon bg-white text-dark shadow-sm fs-3"
                >
                  <i className="fab fa-telegram"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/salahaldeen-alaizari"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon bg-white text-dark shadow-sm fs-3"
                >
                  <i className="fab fa-linkedin"></i>
                </a>
                <a
                  href="https://www.facebook.com/Salahaldeen777988"
                  target="_blank"
                  rel="noreferrer"
                  className="social-icon bg-white text-dark shadow-sm fs-3"
                >
                  <i className="fab fa-facebook"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mt-5">
          <a
            href="#about"
            className="btn btn-primary rounded-circle p-2 animate__animated animate__bounce animate__infinite"
          >
            <i className="fas fa-chevron-down text-white"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
